/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, October 2020
 * @format
 * @flow
 */

import { all, takeLatest, put } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';

interface loginDetailsType {
  latitude: string;
  longitude: string;
  deviceExternalId: string;
  code: string;
}

interface loginType {
  payload: loginDetailsType;
}

export function* login({ payload }: { payload: loginType }): any {
  yield callAPI(payload, ActionTypes.SA_LOGIN, API.login);
}

export default function* root(): any {
  yield all([takeLatest(ActionTypes.SA_LOGIN_REQUEST, login)]);
}
